export default {
    list: {
        kfq: []
    }
}
